/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IMessageDescriptor } from '@hcecbp/i18n-utils';
import { TFunction } from '@scuf/localization/dist/types';
import descriptors from '../../../locales/en-US/descriptors';
import {
  IAny,
  toastMessageTypes
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  apiConflictStatusCode,
  MAGIC_VALUE,
  maxScope1MonthLimit,
  maxScopeOneQuantityAllowed,
  postApiSuccess
} from '../../shared/Utils/Constants';
import { getMonthDropDown } from '../../shared/Utils/Utils';
import { getYearValues } from '../Scope1Table/Scope1TableUtils';
import {
  DropDownWithLoaderContent,
  emptyYearDateQuantity,
  IAllConnectDetails,
  IEmptyYearDateFields
} from './ManualInputTab/ManualInputConfiguration';
const d = descriptors.energyManagement;

export const getFuelDataTxt = (
  t: TFunction,
  activeIndexDataUpload: IAny,
  toggleFeatureAllUpload?: boolean
) => {
  return `${
    (toggleFeatureAllUpload && activeIndexDataUpload === 1) ||
    (!toggleFeatureAllUpload && activeIndexDataUpload === 0)
      ? t(d.ADDNEWFUEL)
      : t(d.ADDNEWCOMPOUND)
  }  ${
    (toggleFeatureAllUpload && activeIndexDataUpload === 1) ||
    (!toggleFeatureAllUpload && activeIndexDataUpload === 0)
      ? t(d.STATIONARYCOMBUSTION)
      : t(d.REFRIGERANTS)
  }`;
};
export const getModalTitle = (
  t: TFunction,
  selectedData: IAny,
  modalType: string,
  activeIndexDataUpload: IAny,
  toggleFeatureAllUpload?: boolean
) => {
  if (modalType === 'missingData' || modalType === 'editFuelData') {
    return `${t(selectedData?.selectedMonth)} ${selectedData?.selectedYear} - ${
      selectedData?.fuelName
    } ${t(d.DETAILS)}`;
  } else {
    getFuelDataTxt(t, toggleFeatureAllUpload, activeIndexDataUpload);
  }
};

export const getDefaulValue = (
  modalType: string,
  value: string,
  value2?: string
) => {
  if (modalType === 'missingData' || modalType === 'editFuelData') {
    return `${!value ? '' : value}`;
  } else {
    return `${value2 ? value2 : ''}`;
  }
};

export const isFieldDisabledForModalType = (modalType: string) => {
  if (modalType === 'missingData' || modalType === 'editFuelData') {
    return true;
  } else {
    return false;
  }
};

export const editFuelModal = (modalType: string | undefined) => {
  return modalType === 'editFuelData' ? true : false;
};

export const isDropdownDisabled = (
  value: string,
  isFieldDisabled: boolean,
  monthDisable: boolean
) => {
  return value === 'year' ? isFieldDisabled : isFieldDisabled || monthDisable;
};

export const isQuantityDisabled = (
  noFuelCB: boolean,
  isEditFuelModal: boolean,
  isEditButtonEnabled: boolean
) => {
  return noFuelCB || (isEditFuelModal && isEditButtonEnabled);
};
export const isFuelDisabled = (allDetails: IAllConnectDetails) => {
  if (allDetails.details[0].noFuelCB || allDetails.details[0].quantity !== '')
    return false;
  else return true;
};

export const getNotifyTypeForAddFuel = (
  response: IAny
): {
  notifyDescription: string | IMessageDescriptor;
  notifyType: toastMessageTypes;
} => {
  const errorObj = {
    notifyDescription: d.UPDATEERRORMESSAGE,
    notifyType: 'error' as toastMessageTypes
  };
  try {
    if (response?.rawResponse?.response?.status === apiConflictStatusCode) {
      return {
        notifyDescription: response?.rawResponse?.response?.data?.toString(),
        notifyType: 'error'
      };
    } else if (typeof response === 'string') {
      return {
        notifyDescription: d.SUCCESS,
        notifyType: 'success'
      };
    } else if (response?.rawResponse?.response?.status === postApiSuccess) {
      return {
        notifyDescription: d.SUCCESS,
        notifyType: 'success'
      };
    } else if (typeof response?.rawResponse?.response?.data === 'string') {
      return {
        notifyDescription: d.UPDATEERRORMESSAGE,
        notifyType: 'error'
      };
    } else {
      return errorObj;
    }
  } catch {
    return errorObj;
  }
};
const validateUniqueMonths = (
  selectedMonths: emptyYearDateQuantity[],
  t: TFunction,
  value: any,
  index: any
) => {
  let test = selectedMonths.map((selectedTime, id) => {
    if (index === id) {
      if (!selectedMonths.some((findVal) => findVal.month === value)) {
        return {
          ...selectedTime,
          month: value,
          monthError: ''
        };
      } else {
        return {
          ...selectedTime,
          month: '',
          monthError: t(d.MONTHERROR)
        };
      }
    } else {
      return selectedTime;
    }
  });

  return test;
};
export const getTempDataDetails = (
  index: number,
  value: string,
  name: string,
  allDetails: IAllConnectDetails,
  t: TFunction
) => {
  let tempDataDetails = [...allDetails.details];
  if (name === 'month') {
    tempDataDetails = validateUniqueMonths(tempDataDetails, t, value, index);
  } else if (name === 'co2EmissionFactor') {
    const re = /^[0-9\b]+$/;
    if (value === '' || re.test(value)) {
      if (value.length <= MAGIC_VALUE.FIVE || value.toString() === '') {
        tempDataDetails[index].quantity = value;
      }
    }
  } else if (name === 'cost') {
    const re = /^[0-9\b]+$/;
    if (value === '' || re.test(value)) {
      if (value.length <= MAGIC_VALUE.TEN || value.toString() === '') {
        tempDataDetails[index].cost = value;
      }
    }
  } else {
    tempDataDetails[index].month = value;
  }
  return tempDataDetails;
};
export const isUnitDropdownDisabled = (
  isFieldDisabled: boolean,
  allDetails: IAllConnectDetails
) => {
  return isFieldDisabled || (allDetails.FuelGasType ? false : true);
};

export const isEditButtonDisabled = (
  isEditButtonEnabled: boolean,
  isEditFuelModal: boolean
) => {
  return isEditButtonEnabled && isEditFuelModal;
};

export const isEditOverRideDisabled = (
  isEditButtonEnabled: boolean,
  isEditFuelModal: boolean,
  allDetails: any
) => {
  return isEditButtonEnabled && isEditFuelModal && allDetails.year !== '';
};
export const checkDataValid = (
  allDetails: IAllConnectDetails,
  checkDetails: boolean
) => {
  return (
    allDetails.Co2 === '' ||
    allDetails.FuelGasType === '' ||
    allDetails.unit === '' ||
    checkDetails
  );
};
export const getUtilityOptions = (
  isFieldDisabled: boolean,
  allDetails: IAllConnectDetails,
  setunit: Function,
  setYearSelection: Function,
  props: DropDownWithLoaderContent,
  categoryName?: string
) => {
  let utilityOptions: { text: string; value: string }[] = [];
  if (isFieldDisabled) {
    utilityOptions.push({
      text: allDetails.FuelGasType,
      value: allDetails.FuelGasType
    });
    setunit([
      {
        text: allDetails.unit,
        value: allDetails.unit
      }
    ]);
    setYearSelection([
      {
        text: allDetails.year,
        value: allDetails.year
      }
    ]);
  } else {
    let updatedData;
    if (categoryName === 'GAS') {
      updatedData = props.data
        ?.map((val: any) => {
          if (val.fuelType.fuelTypeName === 'Gas') {
            return val;
          }
        })
        .filter((val) => val !== undefined);
    } else if (categoryName === 'scope2') {
      updatedData = props.data
        ?.map((val: any) => {
          if (val.fuelType.fuelTypeName !== 'Gas') {
            return val;
          }
        })
        .filter((val) => val !== undefined);
    } else {
      updatedData = props?.data;
    }
    updatedData?.forEach((addFuleDDValue) => {
      utilityOptions.push({
        text: addFuleDDValue.fuelType.fuelTypeName,
        value: addFuleDDValue.fuelType.fuelTypeName
      });
    });
  }
  utilityOptions.sort((a, b) => (a.text < b.text ? -1 : 1));
  return utilityOptions;
};

export const addDataList = (
  allDetails: IAllConnectDetails,
  setAllDetails: Function,
  emptyYearDateQuantity: IEmptyYearDateFields
) => {
  const MaxAccountLimit = maxScope1MonthLimit;
  if (allDetails.details.length < MaxAccountLimit) {
    let tempDataDetails = allDetails.details;

    let tempData = {
      ...emptyYearDateQuantity,
      monthDisable: allDetails.year === '' ? true : false
    };
    tempDataDetails.push(tempData);
    setAllDetails({
      ...allDetails,
      details: tempDataDetails
    });
  }
};

export const isAddDataDisabled = (allDetails: IAllConnectDetails) => {
  if (allDetails?.details.length < 12) {
    return false;
  } else {
    return true;
  }
};

export const fuelGasTypeLabelCheck = (
  activeIndexDataUpload: IAny,
  StationaryCombustion: string,
  Refrigerants: string,
  toggleFeatureAllUpload?: boolean,
  toggleFeatureScopeOne?: boolean,
  toggleFeatureScopeTwo?: boolean,
  scopeTwo?: string,
  toggleFeatureGAS?: boolean,
  meteredGas?: string,
  dataUpload?: string
) => {
  let name;
  if (
    (toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      activeIndexDataUpload == 3) ||
    (!toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      activeIndexDataUpload == 2) ||
    (toggleFeatureAllUpload &&
      !toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      activeIndexDataUpload == 1) ||
    (!toggleFeatureAllUpload &&
      !toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      activeIndexDataUpload == 0)
  ) {
    name = scopeTwo;
  } else if (
    (toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 4) ||
    (!toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 3) ||
    (toggleFeatureAllUpload &&
      !toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 2) ||
    (!toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      !toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 2) ||
    (!toggleFeatureAllUpload &&
      !toggleFeatureScopeOne &&
      toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 1) ||
    (!toggleFeatureAllUpload &&
      !toggleFeatureScopeOne &&
      !toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 0) ||
    (toggleFeatureAllUpload &&
      !toggleFeatureScopeOne &&
      !toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 1) ||
    (toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      !toggleFeatureScopeTwo &&
      toggleFeatureGAS &&
      activeIndexDataUpload == 3)
  ) {
    name = meteredGas;
  } else if (
    (toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      activeIndexDataUpload === 1) ||
    (!toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      activeIndexDataUpload === 0)
  ) {
    name = StationaryCombustion;
  } else if (
    (toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      activeIndexDataUpload === 2) ||
    (!toggleFeatureAllUpload &&
      toggleFeatureScopeOne &&
      activeIndexDataUpload === 1)
  ) {
    name = Refrigerants;
  } else if (toggleFeatureAllUpload && activeIndexDataUpload === 0) {
    name = dataUpload;
  }
  return name;
};
